import React from 'react'

const UpArrowIcon = ({ color }) => {
    return (
        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.332031 4.66895L4.83203 0.668946L9.33203 4.66894" stroke={color ? '#315D99' : '#000'} />
        </svg>
    )
}

export default UpArrowIcon